/**
 * Cap/Tee/Hoodie have real Shopify-native color swatches (their Color
 * option is linked to the standard shopify.color-pattern metafield, so
 * Dawn's own product-variant-picker renders real colored circles). Polo
 * and Sweatshirt's Color options are plain, unlinked text values —
 * confirmed via the Shopify Admin API that linking new colors
 * (Navy/Sport Grey/Charcoal) to that native swatch system requires an
 * Admin-UI-only mechanism that isn't reachable through this project's
 * app scopes or documented mutations (tried both the option-editor's
 * metafield-link control and delete+retype — neither actually linked
 * them, confirmed by re-querying the API afterward).
 *
 * This fills the same visual gap without Shopify's native system: a
 * small colored dot prepended to each Color pill's label, purely in
 * CSS/JS, for any product whose Color option isn't natively swatched.
 * Reuses the exact hex values already established in
 * verse-customizer.js's own COLORS map (for the colors Tee/Hoodie also
 * use) so a color reads the same wherever it appears on the site.
 */
(function () {
  var COLOR_HEX = {
    Black: "#141210",
    White: "#f4f1e9",
    Pink: "#e8b9c4",
    Lavender: "#c7bfe0",
    Anthracite: "#3d3b38",
    "Dark Heather Grey": "#6e6b67",
    "Dark Heather Blue": "#4b5568",
    Ash: "#c9c5be",
    "Carolina Blue": "#7ba7d4",
    "Graphite Heather": "#5c5a56",
    "Light Pink": "#eec6d0",
    Navy: "#1B2A41",
    "Sport Grey": "#9E9E9E",
    Charcoal: "#36454F",
  };

  function init() {
    document.querySelectorAll("fieldset.product-form__input--pill").forEach(function (fieldset) {
      var legend = fieldset.querySelector(".form__label");
      if (!legend || legend.textContent.trim().indexOf("Color") !== 0) return;

      fieldset.querySelectorAll("label").forEach(function (label) {
        if (label.querySelector(".clvry-swatch-dot")) return; // already done
        // label.textContent would also pick up the hidden "Variant sold
        // out or unavailable" text Dawn appends via a sibling span
        // (product-variant-options.liquid: {{ value -}}{{
        // label_unavailable }}) — that text stays in the DOM even while
        // visually hidden, so it silently broke the exact-match lookup
        // below until this was narrowed to just the first text node.
        var firstNode = label.childNodes[0];
        var name = firstNode && firstNode.nodeType === Node.TEXT_NODE ? firstNode.nodeValue.trim() : "";
        var hex = COLOR_HEX[name];
        if (!hex) return; // an already-swatched picker never reaches here (different picker_type/markup) — unknown names are just left alone

        var dot = document.createElement("span");
        dot.className = "clvry-swatch-dot";
        dot.style.background = hex;
        label.insertBefore(dot, label.firstChild);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Dawn's <variant-selects> replaces its ENTIRE inner DOM (all
  // fieldsets/labels, ours included) on every option change — it
  // re-fetches the section from the server to recompute sold-out states
  // across the new combination (see product-info.js: "updateOptionValues
  // replaces the variant-selects DOM element"). That wiped every dot
  // this script had inserted the moment a customer picked a color —
  // confirmed live (dot count went 4 -> 0 right after a selection).
  // Re-running init() on any DOM change fixes it; init() is already
  // idempotent (skips labels that already have a dot), so this is safe
  // to fire often — it's a no-op except right after Dawn's replacement.
  var observer = new MutationObserver(init);
  observer.observe(document.body, { childList: true, subtree: true });
})();
